module.exports = __webpack_public_path__ + "static/media/logo183.e974183a.png";